export interface Review {
  id: string;
  productId: string;
  userName: string;
  userAvatar?: string;
  rating: number;
  title: string;
  comment: string;
  verified: boolean;
  helpfulCount: number;
  date: string;
}

export const reviews: Review[] = [
  {
    id: 'r1',
    productId: 'p1',
    userName: 'James M.',
    rating: 5,
    title: 'Best phone I have ever owned',
    comment: 'The camera is absolutely incredible. The 200MP shots are so detailed and the AI features make editing a breeze. Battery lasts me a full day even with heavy use. Delivery was fast from TechHub Kenya.',
    verified: true,
    helpfulCount: 24,
    date: '2026-05-20',
  },
  {
    id: 'r2',
    productId: 'p1',
    userName: 'Wanjiku N.',
    rating: 4,
    title: 'Great phone but pricey',
    comment: 'Amazing performance and the screen is gorgeous. The S Pen integration is very useful. Only downside is the price but the discount helped. Would recommend for power users.',
    verified: true,
    helpfulCount: 18,
    date: '2026-04-15',
  },
  {
    id: 'r3',
    productId: 'p1',
    userName: 'Peter O.',
    rating: 5,
    title: 'Samsung delivered again',
    comment: 'Upgraded from S22 Ultra and the difference is noticeable. Titanium build feels premium. The night mode photos are mind-blowing.',
    verified: true,
    helpfulCount: 12,
    date: '2026-06-01',
  },
  {
    id: 'r4',
    productId: 'p1',
    userName: 'Amina K.',
    rating: 4,
    title: 'Solid flagship',
    comment: 'Everything works smoothly. The AI summarization and translation features are genuinely useful. Fast charging is a game changer.',
    verified: false,
    helpfulCount: 8,
    date: '2026-05-10',
  },
  {
    id: 'r5',
    productId: 'p2',
    userName: 'David K.',
    rating: 5,
    title: 'iPhone 15 Pro Max is legendary',
    comment: 'The titanium design is stunning in person. Camera system is the best on any smartphone. iOS runs buttery smooth. Worth every shilling for professionals.',
    verified: true,
    helpfulCount: 31,
    date: '2026-03-22',
  },
  {
    id: 'r6',
    productId: 'p2',
    userName: 'Grace W.',
    rating: 5,
    title: 'Perfect for content creation',
    comment: 'I shoot product videos for my business and this phone handles everything. The Action Mode stabilization is like having a gimbal built in.',
    verified: true,
    helpfulCount: 15,
    date: '2026-04-08',
  },
  {
    id: 'r7',
    productId: 'p3',
    userName: 'Brian T.',
    rating: 5,
    title: 'Noise cancellation is insane',
    comment: 'I work in a busy office and these headphones completely block out the noise. Sound quality is crisp with deep bass. 30 hour battery lasts me a full week.',
    verified: true,
    helpfulCount: 22,
    date: '2026-05-05',
  },
  {
    id: 'r8',
    productId: 'p3',
    userName: 'Linda A.',
    rating: 4,
    title: 'Premium headphones at a great price',
    comment: 'Got these during the flash sale and they are fantastic. Comfortable for long wear, great sound, and the quick charge feature is handy.',
    verified: true,
    helpfulCount: 10,
    date: '2026-04-20',
  },
  {
    id: 'r9',
    productId: 'p4',
    userName: 'Charles M.',
    rating: 4,
    title: 'Great TV for the price',
    comment: 'Picture quality is excellent especially for 4K content. WebOS is easy to navigate. Sound is decent but I added a soundbar. Delivery was smooth.',
    verified: true,
    helpfulCount: 14,
    date: '2026-03-30',
  },
  {
    id: 'r10',
    productId: 'p5',
    userName: 'Kevin O.',
    rating: 5,
    title: 'Classic never dies',
    comment: 'The Air Force 1 is timeless. Got them at 9999 which is a steal. Quality leather and they go with everything. Size 44 fit perfectly.',
    verified: true,
    helpfulCount: 19,
    date: '2026-05-15',
  },
  {
    id: 'r11',
    productId: 'p5',
    userName: 'Sarah N.',
    rating: 4,
    title: 'Clean and crisp',
    comment: 'Love the all-white look. Comfortable for daily wear. Just be careful keeping them clean! Fast delivery from SneakerHead Kenya.',
    verified: true,
    helpfulCount: 7,
    date: '2026-04-02',
  },
  {
    id: 'r12',
    productId: 'p6',
    userName: 'Fatima H.',
    rating: 4,
    title: 'Beautiful summer dress',
    comment: 'The floral print is gorgeous and the material is lightweight. Perfect for the Kenyan heat. Medium size fits well. Would buy another color.',
    verified: true,
    helpfulCount: 6,
    date: '2026-05-25',
  },
  {
    id: 'r13',
    productId: 'p7',
    userName: 'John K.',
    rating: 5,
    title: 'Game changer in the kitchen',
    comment: 'This air fryer replaced my deep fryer completely. Fries, chicken, and even samosas come out crispy with barely any oil. 4.1L is perfect for a family of 4.',
    verified: true,
    helpfulCount: 28,
    date: '2026-03-18',
  },
  {
    id: 'r14',
    productId: 'p7',
    userName: 'Mary W.',
    rating: 5,
    title: 'Best purchase this year',
    comment: 'Had doubts about air fryers but this Philips one proved me wrong. Easy to clean, cooks evenly, and the recipe book included was helpful.',
    verified: true,
    helpfulCount: 16,
    date: '2026-04-25',
  },
  {
    id: 'r15',
    productId: 'p8',
    userName: 'TechGuy KE',
    rating: 5,
    title: 'Absolute beast of a laptop',
    comment: 'The M3 Pro chip handles everything I throw at it - video editing, coding, design work. The XDR display is the best laptop screen I have ever seen.',
    verified: true,
    helpfulCount: 11,
    date: '2026-02-28',
  },
  {
    id: 'r16',
    productId: 'p9',
    userName: 'Samuel N.',
    rating: 4,
    title: 'Good fridge for the price',
    comment: 'Keeps everything cold and fresh. The frost-free feature saves me from manual defrosting. Energy bill has not spiked either. Good value.',
    verified: true,
    helpfulCount: 9,
    date: '2026-05-12',
  },
  {
    id: 'r17',
    productId: 'p10',
    userName: 'Diana M.',
    rating: 4,
    title: 'Reliable power bank',
    comment: 'Charges my phone about 4-5 times on a single charge. The LED display is handy to know remaining power. Compact size fits in my bag.',
    verified: true,
    helpfulCount: 13,
    date: '2026-04-10',
  },
  {
    id: 'r18',
    productId: 'p11',
    userName: 'Chris B.',
    rating: 5,
    title: 'JBL sound quality is unmatched',
    comment: 'Bass is punchy without being muddy. Perfect for outdoor gatherings and picnics. 12 hours battery easily lasts a full day at the beach. Waterproof too!',
    verified: true,
    helpfulCount: 20,
    date: '2026-05-08',
  },
  {
    id: 'r19',
    productId: 'p12',
    userName: 'Ruth A.',
    rating: 4,
    title: 'Great laptop for students',
    comment: 'Using this for university and it handles all my coursework plus some light gaming. 16GB RAM means I can have many tabs open. Good build quality.',
    verified: true,
    helpfulCount: 11,
    date: '2026-04-05',
  },
  {
    id: 'r20',
    productId: 'p13',
    userName: 'Esther K.',
    rating: 4,
    title: 'Visible results in 2 weeks',
    comment: 'My skin texture has improved noticeably. The SPF 30 means I can wear it during the day without adding sunscreen. Non-greasy formula.',
    verified: true,
    helpfulCount: 8,
    date: '2026-05-18',
  },
  {
    id: 'r21',
    productId: 'p14',
    userName: 'Michael R.',
    rating: 5,
    title: 'Running shoes of the year',
    comment: 'The boost midsole is incredibly responsive. My morning runs feel effortless now. The upper is breathable which is perfect for Kenyan weather.',
    verified: true,
    helpfulCount: 17,
    date: '2026-03-15',
  },
  {
    id: 'r22',
    productId: 'p15',
    userName: 'Joyce L.',
    rating: 4,
    title: 'Does the job well',
    comment: 'Washes clothes thoroughly and the magic filter catches all the lint. A bit noisy on the spin cycle but overall great for the price.',
    verified: true,
    helpfulCount: 6,
    date: '2026-04-22',
  },
  {
    id: 'r23',
    productId: 'p16',
    userName: 'George P.',
    rating: 4,
    title: 'Solid printer for home office',
    comment: 'Setup was straightforward via WiFi. Print quality is good for documents and decent for photos. Wireless printing from my phone is convenient.',
    verified: true,
    helpfulCount: 9,
    date: '2026-05-01',
  },
];

export const getReviewsByProduct = (productId: string): Review[] =>
  reviews.filter((r) => r.productId === productId).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export const getReviewStats = (productId: string) => {
  const productReviews = getReviewsByProduct(productId);
  const total = productReviews.length;
  const avg = total > 0 ? productReviews.reduce((s, r) => s + r.rating, 0) / total : 0;
  const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  productReviews.forEach((r) => {
    const key = Math.min(5, Math.max(1, Math.round(r.rating))) as 1 | 2 | 3 | 4 | 5;
    counts[key] += 1;
  });
  return { total, average: Number(avg.toFixed(1)), counts };
};